import * as React from 'react';

function ChevronRightSmall(props) {
    return React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", className: "c-pieIcon c-pieIcon--ChevronRightSmall", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M4.04375 12.18L9.39875 7.00004L4 1.82004L4.875 0.857544L10.4137 6.20379C10.6291 6.42164 10.7499 6.7156 10.7499 7.02192C10.7499 7.32823 10.6291 7.6222 10.4137 7.84004L4.945 13.125L4.04375 12.18Z" }));
}

export { ChevronRightSmall as default };
